import React, { type ComponentType } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { fontSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages';

export type Props = {
	ruleIds: string[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ListItemComponent: ComponentType<any>;
	intl: IntlShape;
};

function RuleList(props: Props) {
	const {
		intl: { formatMessage },
		ruleIds,
		ListItemComponent,
	} = props;
	const headerText = formatMessage(messages.header);

	return (
		<div>
			<H2Header>{headerText}</H2Header>
			{ruleIds.map((id) => (
				<ListItemComponent key={id} ruleSetId={id} />
			))}
		</div>
	);
}

export default injectIntl(RuleList);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const H2Header = styled.h2({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N300),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `2px solid ${token('color.border', colors.N30)}`,
	padding: token('space.100', '8px'),
	marginBottom: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
});
